import { motion } from 'framer-motion';

interface SJChatSuggestionsProps {
  questions: string[];
  onSelect: (question: string) => void;
  disabled?: boolean;
}

export function SJChatSuggestions({ questions, onSelect, disabled }: SJChatSuggestionsProps) {
  if (!questions.length) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: 0.1 }}
      className="flex flex-wrap gap-2"
    >
      {questions.map((question, i) => (
        <motion.button
          key={i}
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.2, delay: i * 0.05 }}
          onClick={() => !disabled && onSelect(question)}
          disabled={disabled}
          className="rounded-full border border-[var(--sj-border)] bg-[var(--sj-surface)] px-3.5 py-2 text-xs text-[var(--sj-text-secondary)] transition-all hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700 disabled:opacity-50 disabled:cursor-not-allowed dark:hover:bg-primary-950/20 dark:hover:text-primary-300"
        >
          {question}
        </motion.button>
      ))}
    </motion.div>
  );
}
